import React, { useContext } from "react";
import SidebartContext from '../../context/sidebar/sidebarContext'

import styles from './index.module.scss';

const SidebarLogo = () => {

  const sidebartContext = useContext(SidebartContext);
  const { toggleCollapsedSideNav } = sidebartContext

  return (
    <section className={styles.sidebar_logo_conponent}>
      <img alt="logo2" src={require("assets/images/logos/250Logo.png")}
        onClick={toggleCollapsedSideNav}
      />
    </section>
  );
};
export default SidebarLogo;
